import jQuery from 'jquery'

document.addEventListener('DOMContentLoaded', () => {
  const selectedClass = 'selected'
  const variationLinks = document.querySelectorAll('.alpha-product-variation-link[data-variation-key]')
  if (variationLinks.length) {
    variationLinks.forEach((variationLinkEl) => {
      const parentEl = variationLinkEl.closest('[data-variation-attribute]')
      if (parentEl) {
        const attribute = parentEl.getAttribute('data-variation-attribute')
        const variationKey = variationLinkEl.getAttribute('data-variation-key')
        const linkedSelectEl = document.getElementById(attribute)
        if (linkedSelectEl) {
          variationLinkEl.addEventListener('click', (e) => {
            e.preventDefault()

            if (!variationLinkEl.parentElement.classList.contains(selectedClass)) {
              // remove selected class from any other element
              const selectedEl = parentEl.querySelector(`.${selectedClass}`)
              if (selectedEl) {
                selectedEl.classList.remove(selectedClass)
              }

              // mark clicked variation as selected and update hidden select value
              variationLinkEl.parentElement.classList.add(selectedClass)
              jQuery(linkedSelectEl).val(variationKey)
              jQuery(linkedSelectEl).change()
            } else {
              variationLinkEl.parentElement.classList.remove(selectedClass)
              jQuery(linkedSelectEl).val('')
              jQuery(linkedSelectEl).change()
            }
          })
        }
      }
    })

    // also reset selected variation tag when clicking on reset variations button
    const resetVariationsEl = document.querySelector('.reset_variations')
    if (resetVariationsEl) {
      resetVariationsEl.addEventListener('click', (e) => {
        const selectedElements = document.querySelectorAll(`.alpha-product-variation-tags .${selectedClass}`)
        selectedElements.forEach((selectedEl) => selectedEl.classList.remove(selectedClass))
      })
    }
  }
})
